import { z } from "zod";

const reward = z.object({
  promoCode: z.string(),
  amount: z.string(),
  benefitId: z.string(),
  description: z.string(),
});

const item = z.object({
  code: z.string(),
  category: z.string(),
  ownerId: z.string().uuid(),
  state: z.enum(["ACTIVE", "INACTIVE"]),
  modificationDate: z.string(),
  reward,
});

export const serverResponse = z.array(item);
